<template>
  <div class="card-visit-note">
    <div class="d-flex">
      <i class="icon-HISTORY-Copy-21 font-42"></i>
      <h3 class="pb-2 text-red pl-3">หมายเหตุ</h3>
    </div>
    <textarea
      cols="56"
      rows="5"
      placeholder="ระบุหมายเหตุ"
      :value="noteInput"
      @keyup="onkeyNote"
      ref="noteRef"
      style="width: 100%;"
    />
  </div>
</template>

<script>
export default {
  props: {
    data: String
  },
  computed: {
    noteInput() {
      const rusult = this.data == '' ? null : this.data
      return rusult
    }
  },
  methods: {
    onkeyNote() {
      const data = this.$refs.noteRef.value
      this.$emit('add', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-visit-note {
  border-radius: 8px;
  background-color: #ffffff;
  padding: 30px;
}
textarea {
  padding: 15px;
  margin: 15px 0px;
  border: 1px solid #bdbdbd;
}
.icon-HISTORY-Copy-21:before {
  content: '\e98f';
  color: #868585;
}
</style>
